<template>
    <div class="bg-color">
        <Navbar />
        <Header :category="'visitors'" :bannerTitle="bannerTitle" :breadCrumb="borrowSpaceCrumb" />
        <SmartVenueContent />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
    import Navbar from 'components/DefaultHome/Layout/NavbarStyleTwo'
    import Header from 'components/DefaultHome/KECC5G/Common/Header'
    import SmartVenueContent from './SmartVenueContent'
    import FooterTop from 'components/DefaultHome/Layout/FooterTop'
    import FooterBottom from 'components/DefaultHome/Layout/BacktopButton'
    export default {
        name: 'SmartVenueMain',
        components: {
            Navbar,
            Header,
            SmartVenueContent,
            FooterTop,
            FooterBottom,
        },
        data() {
            return {
                bannerTitle: this.$t('navbar.menu_1'),
                borrowSpaceCrumb: [
                    {
                        name: this.$t('navbar.menu_1'),
                        path: "/smartvenue"
                    }
                ]
            }
        }
    }
</script>
